import * as React from 'react';

type VolumeUpSvgProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
};

const VolumeUpSvg: React.FC<VolumeUpSvgProps> = ({ width = 28, height = 28, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="VolumeUpSvg"
    >
      <path
        d="M22.1667 13.971C22.1667 12.3571 21.7389 10.8842 20.8833 9.55225C20.0278 8.2203 18.8806 7.22377 17.4417 6.56266C17.15 6.42655 16.9361 6.21752 16.8 5.93558C16.6639 5.65364 16.6444 5.36683 16.7417 5.07516C16.8583 4.76405 17.0674 4.54044 17.3688 4.40433C17.6701 4.26822 17.9764 4.26822 18.2875 4.40433C20.1736 5.24044 21.6806 6.51891 22.8083 8.23975C23.9361 9.96058 24.5 11.871 24.5 13.971C24.5 16.071 23.9361 17.9814 22.8083 19.7022C21.6806 21.4231 20.1736 22.7016 18.2875 23.5377C17.9764 23.6738 17.6701 23.6738 17.3688 23.5377C17.0674 23.4016 16.8583 23.1779 16.7417 22.8668C16.6444 22.5752 16.6639 22.2884 16.8 22.0064C16.9361 21.7245 17.15 21.5154 17.4417 21.3793C18.8806 20.7182 20.0278 19.7217 20.8833 18.3897C21.7389 17.0578 22.1667 15.5849 22.1667 13.971ZM8.16667 17.5002H4.66667C4.33611 17.5002 4.05903 17.3884 3.83542 17.1647C3.61181 16.9411 3.5 16.6641 3.5 16.3335V11.6668C3.5 11.3363 3.61181 11.0592 3.83542 10.8356C4.05903 10.612 4.33611 10.5002 4.66667 10.5002H8.16667L12.0167 6.65016C12.3861 6.28072 12.809 6.19808 13.2854 6.40225C13.7618 6.60641 14 6.971 14 7.496V20.5043C14 21.0293 13.7618 21.3939 13.2854 21.5981C12.809 21.8022 12.3861 21.7196 12.0167 21.3502L8.16667 17.5002ZM19.25 14.0002C19.25 14.8168 19.0653 15.5897 18.6958 16.3189C18.3264 17.0481 17.8403 17.646 17.2375 18.1127C17.0431 18.2293 16.8438 18.2342 16.6396 18.1272C16.4354 18.0203 16.3333 17.8502 16.3333 17.6168V10.3252C16.3333 10.0918 16.4354 9.92169 16.6396 9.81475C16.8438 9.7078 17.0431 9.71266 17.2375 9.82933C17.8403 10.3154 18.3264 10.9279 18.6958 11.6668C19.0653 12.4057 19.25 13.1835 19.25 14.0002ZM11.6667 10.3252L9.15833 12.8335H5.83333V15.1668H9.15833L11.6667 17.6752V10.3252Z"
        fill="white"
      />
    </svg>
  );
};

export default VolumeUpSvg;
